import React from 'react';
import { Button } from '@chakra-ui/react';
import { FiDownload } from 'react-icons/fi';

// Botão compartilhado de download de evidências — mesmo visual em todas as
// telas que hoje reimplementam a lógica de download (cada uma mantém seu
// próprio onClick/isLoading; este componente é só a casca visual).
const EvidenceDownloadButton = ({
 isLoading,
 isDisabled,
 onClick,
 label = 'Baixar evidências',
 ...rest
}) => (
 <Button
  leftIcon={<FiDownload size={18} />}
  variant='outline'
  borderColor='#DEE5E4'
  color='#5C6066'
  bg='white'
  height='51px'
  fontWeight={600}
  _hover={{ bg: '#F1F5FA', borderColor: '#0073BB', color: '#0073BB' }}
  isLoading={isLoading}
  isDisabled={isDisabled}
  onClick={onClick}
  {...rest}
 >
  {label}
 </Button>
);

export default EvidenceDownloadButton;
